import { TemplateReferenceInput } from '@e-socna/data-layer';
import type { ReadonlyDeep } from 'type-fest';

import { pruneInput } from '../../../utils/prune-input.util';

import type { DocumentEditorCmp_RecursiveSection } from '../fragments/recursive-section.fragment';

export function templateForm2ApiMapper(
  template: ReadonlyDeep<
    DocumentEditorCmp_RecursiveSection['template'] | TemplateReferenceInput
  >,
) {
  if (!template) {
    return template;
  }

  return pruneInput(template, TemplateReferenceInput);
}
